/* eslint-disable max-len */
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import DashboardSideMenuBuilder from './DashboardSideMenuBuilder';
import RespondentsSideMenuBuilder from './RespondentsSideMenuBuilder';
import AssessmentsSideMenuBuilder from './AssessmentsSideMenuBuilder';
import SurveysSideMenuBuilder from './SurveysSideMenuBuilder';
import AccountManagementSideMenuBuilder from './AccountManagementSideMenuBuilder';
import OrganisationManagementSideMenuBuilder from './OrganisationManagementSideMenuBuilder';
import DocumentsSideMenuBuilder from './DocumentsSideMenuBuilder';
import ItemBankManagementSideMenuBuilder from './ItemBankManagementSideMenuBuilder';
import i18nMessages from './SideMenuTranslations';
import {
  accountTypeIsClient, accountTypeIsGPI, userHasItemBankAdminRole, userHasMemberRole,
  userHasSuperAdminRole,
} from './SideMenuHelper';
import DocumentManagementSideMenuBuilder from './DocumentManagementSideMenuBuilder';
// import SuperMatchSideMenuBuilder from './SuperMatchSideMenuBuilder';

const MenuBuilder = (accountId, userRole, accountType, payedBy, isHeadOfFamily, superMatches, edges) => {
  const { formatMessage } = useIntl();
  const history = useHistory();

  const dashboard = DashboardSideMenuBuilder(accountId).buildDashboardMenu();
  const respondents = RespondentsSideMenuBuilder(accountId).buildRespondentMenu();
  const assessments = AssessmentsSideMenuBuilder(accountId, accountType).buildAssessmentMenu();
  const surveys = SurveysSideMenuBuilder(accountId, accountType).buildSurveysMenu();
  // const superMatchesOfAccount = SuperMatchSideMenuBuilder(accountId, accountType, superMatches).buildSuperMatchMenu();
  const accountManagement = AccountManagementSideMenuBuilder(accountId, accountType, payedBy, isHeadOfFamily).buildAccountManagementMenu();
  const organisationManagement = OrganisationManagementSideMenuBuilder(
    accountId,
    accountType,
  ).buildOrganisationSideMenu();
  const documents = DocumentsSideMenuBuilder(accountId, accountType, userRole).buildDocumentsMenu();
  const itemBankManagement = ItemBankManagementSideMenuBuilder(accountId)
    .buildItemBankManagementMenu();
  const documentManagement = DocumentManagementSideMenuBuilder(accountId).buildDocumentManagementMenu();

  const userIsMember = userHasMemberRole(userRole);
  const userIsItemBankAdmin = userHasItemBankAdminRole(userRole);
  const userIsSuperAdmin = userHasSuperAdminRole(userRole);
  const accountIsClient = accountTypeIsClient(accountType);
  const accountIsGPI = accountTypeIsGPI(accountType);

  const buildMenu = () => {
    const menu = [];

    if (userRole === null) {
      return menu;
    }

    const home = {
      label: formatMessage(i18nMessages.home),
      icon: 'fa fa-home',
      command: () => {
        history.push('/');
      },
    };

    if (edges.length > 1) {
      menu.push(home);
    }

    if (userIsMember) {
      menu.push(dashboard);
      menu.push(respondents);
      menu.push(assessments);
      menu.push(surveys);
      // menu.push(superMatchesOfAccount);
      menu.push(documents);
    }

    if (!userIsMember && accountIsClient) {
      menu.push(dashboard);
      menu.push(respondents);
      menu.push(assessments);
      menu.push(surveys);
      // menu.push(superMatchesOfAccount);
      menu.push(accountManagement);
      menu.push(documents);
    }

    if (!userIsMember && !accountIsClient) {
      menu.push(dashboard);
      menu.push(respondents);
      menu.push(assessments);
      menu.push(surveys);
      // menu.push(superMatchesOfAccount);
      menu.push(accountManagement);
      menu.push(organisationManagement);

      if (accountIsGPI && userIsItemBankAdmin) menu.push(itemBankManagement);
      if (accountIsGPI && userIsSuperAdmin) menu.push(documentManagement);

      menu.push(documents);
    }

    return menu;
  };

  return {
    buildMenu,
  };
};

export default MenuBuilder;
